var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('persistent-modal-login',{key:_vm.update_modal_login,attrs:{"open_modal":_vm.open_modal_login,"redirect":_vm.redirect}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }